<template>
  <div class='ct-breadcrumb breadcrumb-container container'>
    <template v-if="items">
      <ol class="breadcrumb" aria-label="breadcrumb">
        <li class="breadcrumb-item">
          <router-link :to="{ name: 'Home', params: {}}">{{ $t(`ct-home`) }}</router-link>
        </li>
        <li
          class="breadcrumb-item"
          v-for="(item, index) of items"
          :key="index"
          :class="{'active': item.active }"
        >
          <a
            v-if="item.active"
            href="#"
            :class="{'active': item.active }"
            @click.prevent
          >{{ $t(`ct-${item.title}`) }}</a>
          <a
            href="#"
            @click.prevent="changePage(item)"
            v-else-if="item.params"
          >{{ $t(`ct-${item.title}`) }}</a>
          <router-link v-else :to="{ name: item.link, params: {}}">{{ $t(`${item.title}`) }}</router-link>
        </li>
      </ol>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: []
    };
  },
  watch: {
    $route: function(route) {
      this.items = route.meta.breadcrumb;
    }
  },
  methods: {
    changePage(item) {
      if (this.$route.params[item.params]) {
        this.$router.push({
          name: item.link,
          params: { id: this.$route.params[item.params] }
        });
      }
    }
  },
  mounted() {
    this.items = this.$route.meta.breadcrumb;
  }
};
</script>

<style lang="scss" scoped>
  .container {
    @media (min-width: 1200px) {
      max-width: 1160px!important;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/dashboard/components/Breadcrumb.vue